import { createBrowserRouter, Navigate } from 'react-router-dom';
import Simple from '../layouts/Simple/Simple.tsx';
import Routes from './Routes.ts';
import HomePage from '../pages/HomePage.tsx';
import LoginPage from '@/pages/LoginPage.tsx';
import SandboxPage from '@/pages/SandboxPage.tsx';
import { transformRouterConfig } from '@/router/transformRouter.tsx';
import Admin from '@/layouts/Admin/Admin.tsx';
import RestaurantsPage from '@/pages/admin/RestaurantsPage.tsx';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.tsx';
import ResetPasswordPage from '@/pages/ResetPasswordPage.tsx';
import RestaurantReservationsPage from '@/pages/admin/RestaurantReservationsPage.tsx';
import RestaurantReservationLogs from '@/pages/admin/RestaurantReservationLogsPage.tsx';
import ReservationsPage from '@/pages/manager/ReservationsPage.tsx';
import FaqPage from '@/pages/admin/FaqPage.tsx';
import IntegrationsPage from '@/pages/admin/IntegrationsPage.tsx';

const router = createBrowserRouter(
  transformRouterConfig([
    // Simple layout
    {
      path: '/',
      element: <Simple />,
      middleware: ['loggedIn'],
      children: [
        {
          path: Routes.HOME,
          element: <HomePage />,
        },
      ],
    },
    // Simple layout
    {
      path: '/',
      element: <Simple />,
      children: [
        {
          path: Routes.RESET_PASSWORD,
          element: <ResetPasswordPage />,
        },
      ],
    },
    {
      path: '/',
      element: <Simple />,
      middleware: ['notLoggedIn'],
      children: [
        {
          path: Routes.FORGOT_PASSWORD,
          element: <ForgotPasswordPage />,
        },
        {
          path: Routes.LOGIN,
          element: <LoginPage />,
        },
      ],
    },
    // Admin layout admin
    {
      path: '/',
      element: <Admin.Layout />,
      middleware: ['authAdmin'],
      children: [
        {
          path: Routes.ADMIN__DASHBOARD,
          element: <Navigate to={Routes.ADMIN__RESTAURANTS} />,
        },
        {
          path: Routes.ADMIN__RESTAURANTS,
          element: <RestaurantsPage />,
        },
        {
          path: Routes.ADMIN__RESTAURANTS__RESERVATIONS,
          element: <RestaurantReservationsPage />,
        },
        {
          path: Routes.ADMIN__RESTAURANTS__RESERVATIONS__LOGS,
          element: <RestaurantReservationLogs />,
        },
        {
          path: Routes.ADMIN__FAQ,
          element: <FaqPage />,
        },
        {
          path: Routes.ADMIN__INTEGRATIONS,
          element: <IntegrationsPage />,
        },
      ],
    },
    // Admin layout manager
    {
      path: '/',
      element: <Admin.Layout />,
      middleware: ['authManager'],
      children: [
        {
          path: Routes.MANAGER__DASHBOARD,
          element: <Navigate to={Routes.MANAGER__RESERVATIONS} />,
        },
        {
          path: Routes.MANAGER__RESERVATIONS,
          element: <ReservationsPage />,
        },
        {
          path: Routes.MANAGER__RESERVATIONS__LOGS,
          element: <RestaurantReservationLogs />,
        },
      ],
    },
    {
      path: '/sandbox',
      element: <SandboxPage />,
    },
  ])
);

export default router;
